import { Component, h, Host } from "@stencil/core";

@Component({
    tag: "ux-modal-content",
    styleUrl: "modal-content.scss",
    shadow: false
})
export class ModalContent {
    render() {
        return (
            <Host class="ux-modal-content">
                <slot />
            </Host>
        );
    }
}
